//企業管理者ページ
import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import config from '../../Config/key';
import {
  Table,
  Divider,
  Button,
  message,
  Typography,
  Modal,
  Select,
  Spin,
  Input,
} from 'antd';
import { userRole } from '../../Config/userRole';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// テーブル強化 PJ Ph.3: メイン一覧テーブルに 列リサイズ + ソート + 省略
// （発行チケット確認モーダルのトークン一覧テーブルも同処理を適用済み）
import {
  PageContainer,
  StatusBadge,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
  numberSorter,
} from '../../common';
import { noAccessibleSeasonMessage } from '../../../utils/seasonFilter';
import {
  hidesMemberStatus,
  filterStatusSeasons,
  filterStatusTokens,
  userHasStatusToken,
} from '../../../utils/answerStatusView';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import { surveyCode } from '../../Config/surveyCode';
import { surveyStatus } from '../../Config/surveyStatus';
const ExcelJS = require('exceljs');
// const { confirm } = Modal;
const { Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;
// 「実施有無：未回答」の対象ステータス（実施前・一時保存中・期限切れ）
const UNANSWERED_STATUSES = [0, 1, 7];
function CorpMgrPage() {
  const [Users, setUsers] = useState([]);
  const [tUsers, setTUsers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAnswerd, setIsAnswerd] = useState(9);
  // const [user, setUser] = useState([]);
  const [userToken, setUserToken] = useState([]);
  const [allToken, setAllToken] = useState([]);
  // const [downloadToken, setDownloadToken] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  const [surveySeason, setSurveySeason] = useState([]);
  const [selSurveySeason, setSelSurveySeason] = useState([]);
  // const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  const [role360, setRole360] = useState(1); //選択した360度関係：１：本人、２：上司、３：部下・同僚
  const [groupSeason, setGroupSeason] = useState([]);
  const [questionSetFilter, setQuestionSetFilter] = useState([]); //全ての設問セット
  const [selQuestionSetFilterId, setSelQuestionSetFilterId] = useState(''); //選択した設問セットID
  const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  // 詳細検索パネルの表示状態
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  // 詳細検索の条件
  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchRoles, setSearchRoles] = useState([]);
  const usr = useSelector((state) => state.user);

  // 回答状況指定でエンゲージメント・その他の両方が見られないシーズン管理者は、URL で直接開いてもトップへ戻す
  // （メニューにも出さない。サーバーも見られない回答状況を返さない。utils/answerStatusView.js・2026-10 追加パッチ）
  const history = useHistory();
  useEffect(() => {
    if (hidesMemberStatus(usr.userData)) history.push('/');
  }, [usr, history]);
  // let selGroupInfo = {};
  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log({ usr });
      const [surveyInfo, res, seasonInfo, res2] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get(`${config.USER_SERVER}/group/${usr.userData.groupCode}`), //user全体
        Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        Axios.get(`/api/surveyToken/g/${usr.userData.groupCode}`), //グループの全てのトークン情報
        // Axios.get(`/api/group/${usr.userData.groupCode}`), //ログインユーザのグループ情報を取得
      ]);
      if (!surveyInfo.data.survey) throw 'サーベイ取得に失敗しました。';
      if (!seasonInfo.data.surveySeason)
        throw 'サーベイシーズン取得に失敗しました。';
      // console.log({ seasonInfo });
      setSurvey(surveyInfo.data.survey);
      setSurveySeason(seasonInfo.data.surveySeason);
      // setSelGroupInfo(groupInfo.data.group.survey_season);
      setGroupSeason(
        seasonInfo.data.surveySeason.filter(
          (item) => item.group_code === usr.userData.groupCode
        )
      );
      // selGroupInfo = groupInfo.data.group;
      if (res2.data.success) {
        // console.log(res2);
        // シーズン管理者に出すチケットは使うところ（チケット詳細）で回答状況指定・シーズン指定に絞る
        setAllToken(res2.data.tokenInfo);
        // setDownloadToken(
        //   res2.data.tokenInfo.filter(function (tokenInfo) {
        //     return (
        //       tokenInfo.survey_status === 5 && tokenInfo.survey_code === '10010'
        //     ); //実施済み：5
        //   })
        // );
      }
      let userData = res.data.users;
      // console.log({ res });
      if (res.data.success) {
        await userData.map((user) => {
          user.fullName = user.lastname + ' ' + user.name;
          user.roleText = userRole[user.role];
          // console.log(user.survey_token);
          // シーズン管理者は回答状況の画面に出せるチケットだけを数える（回答状況指定・シーズン指定。
          // 以前は割り当て外のシーズンも合計に入っていた。2026-10 追加パッチ。role 7 以外はすべてのチケット＝従来どおり）
          const countTokens = filterStatusTokens(user.survey_token, usr.userData);
          if (countTokens.length === 0) {
            user.takeTokenCnt = 0;
            user.usedTokenCnt = 0;
            user.surveyProgress = 0;
            // console.log('here');
          } else {
            user.takeTokenCnt = countTokens.length;
            user.usedTokenCnt = countTokens.filter(function (tokenInfo) {
              return tokenInfo.survey_status === 5; //実施済み：5
            }).length;
            user.surveyProgress = parseInt(
              (user.usedTokenCnt / user.takeTokenCnt) * 100
            );
          }
          return user;
        });
        //（Ph.5）role 7 は回答状況の画面に出せるチケット（回答状況指定・シーズン指定）を持つユーザーのみを表示。
        // 絞り込みの無い role 7 は role 3 と同様に全ユーザーを表示する（フォールバック）。
        // 部署指定の範囲外で、360度系チームの協力者としてだけサーバーが返した人（outside_dept）も出さない
        // （チーム回答状況で数えるためのデータ。2026-10 追加パッチ）。role 7 以外には影響なし。
        const displayUsers = userData.filter(
          (u) => !u.outside_dept && userHasStatusToken(u, usr.userData)
        );
        // console.log(displayUsers);
        setUsers(displayUsers);
        setTUsers(displayUsers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  // 詳細検索条件をUsersに適用した表示用リスト
  // 名前・メールは部分一致（大文字小文字無視）、権限は選択値のいずれか一致
  const displayUsers = useMemo(() => {
    const nameKw = searchName.trim().toLowerCase();
    const emailKw = searchEmail.trim().toLowerCase();
    return Users.filter((u) => {
      if (!u) return false;
      if (nameKw) {
        const target = (u.fullName || '').toLowerCase();
        if (!target.includes(nameKw)) return false;
      }
      if (emailKw) {
        const target = (u.email || '').toLowerCase();
        if (!target.includes(emailKw)) return false;
      }
      if (searchRoles.length > 0) {
        if (!searchRoles.includes(u.role)) return false;
      }
      return true;
    });
  }, [Users, searchName, searchEmail, searchRoles]);

  // 詳細検索の条件が一つでも有効か
  const hasActiveSearch =
    searchName.trim() !== '' ||
    searchEmail.trim() !== '' ||
    searchRoles.length > 0;

  // 詳細検索条件のクリア
  const clearAdvancedSearch = () => {
    setSearchName('');
    setSearchEmail('');
    setSearchRoles([]);
  };

  //選択したユーザのPDFリストのモーダルを表示
  const viewTicketHandler = async (user, e) => {
    e.preventDefault();
    // console.log({ user });
    // console.log({ survey });
    try {
      // console.log({ usedToken });
      // const survey_status = 5;
      // const res = await Axios.get(
      //   // `/api/surveyToken/s/${userId}/${survey_status}`
      //   `${config.USER_SERVER}/${userId}`
      // );
      // console.log(res);
      // if (res.data.success) {
      // await readDB();
      // message.success('論理削除しました。');
      // setUser(res.data.user);
      let ut = [];
      //対象ユーザーのトークンのみ抽出し、role 7 の場合は回答状況指定・シーズン指定の範囲のトークンに絞り込む
      //（Ph.5: role 7 ユーザーに付与外シーズンのチケットが見えないようにする。
      //  サーベイ結果確認ボタンもこの絞り込み後の ut 配列上にレンダされるため、
      //  PDF 生成画面への露出も同時に遮断される）
      const accessibleTokens = filterStatusTokens(
        allToken.filter((t) => t.user === user._id),
        usr.userData
      );
      accessibleTokens.forEach((element) => {
        let element2 = element;
        element2.groupCode = element.group_code;
        // element2.surveyName = surveyCode[element.survey_code];
        element2.surveyStatusName = surveyStatus[element.survey_status];
        //実施済みの時だけ日付を表示
        if (element.survey_status === 5) {
          element2.update = ymdhms(element.updatedAt);
          element2.study_end_date = ymdhms(element.updatedAt);
        } else {
          element2.update = '-';
        }
        element2.tokenExpire = ymdhms(element.token_expire);
        element2.tokenValid = ymdhms(element.token_valid);
        element2.groupCode = element.group_code;
        let surveyName = '';

        //シーズンIDが存在するならシーズン名を表示
        if (element.survey_season_id) {
          let surveySeasonInfo = surveySeason.find(
            (item) => item._id === element.survey_season_id
          );
          surveyName = surveySeasonInfo.season_name;
          element2.e3_option = surveySeasonInfo.e3_option;
          element2.tName = surveySeasonInfo.t_name;
        } else {
          surveyName = surveyCode[element.survey_code];
        }
        //Question Set Idが存在するならQuestionSet名を表示
        if (element.question_set_id) {
          let surveyInfo = survey.find(
            (item) => item._id === element.survey_id
          );
          // console.log({ surveyInfo });
          surveyName =
            surveyName +
            ' : ' +
            surveyInfo.question_set.find(
              (item) => item._id === element.question_set_id
            ).set_name;
        }

        // if (element.question_set_id) {
        //   let surveyInfo = survey.find(
        //     (item) => item._id === element.survey_id
        //   );
        //   // console.log({ surveyInfo });
        //   element2.surveyName =
        //     surveyCode[element.survey_code] +
        //     '(' +
        //     surveyInfo.question_set.find(
        //       (item) => item._id === element.question_set_id
        //     ).set_name +
        //     ')';
        // } else {
        //   element2.surveyName = surveyCode[element.survey_code];
        // }
        element2.group_name = user.company;
        element2.company = user.company;
        element2.user_name = user.fullName;
        element2.emp_no = user.emp_no;
        element2.department = user.department;
        element2.surveyName = surveyName;
        ut.push(element2);
      });
      // 各チケットのレポート「本人ダウンロード回数」を取得して付与する
      try {
        const tokenIds = ut.map((t) => t._id);
        const dlRes = await Axios.post('/api/surveyToken/download-counts', {
          tokenIds,
        });
        if (dlRes.data.success) {
          const counts = dlRes.data.counts || {};
          ut.forEach((t) => {
            t.dlCount = counts[String(t._id)] || 0;
          });
        }
      } catch (e) {
        console.log(e);
      }
      setUserToken(ut);
      setViewModal(true);
      // }
    } catch (error) {
      alert('サーベイ情報が読み込めませんでした。');
      console.log(error);
    }
  };

  // const viewSurveyResultHandler = async (tokenInfo, e) => {
  //   e.preventDefault();
  //   // console.log({ tokenInfo });
  //   try {
  //     let url = '';
  //     if (tokenInfo.groupCode) {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${tokenInfo.groupCode}/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     } else {
  //       url = `${config.S3_URL}/${config.S3_ENV}/user/${tokenInfo.user}/rcep_${tokenInfo._id}.pdf`;
  //     }
  //     window.open(url, '_blank');
  //   } catch (error) {
  //     alert('サーベイ結果確認ができません。');
  //     console.log(error);
  //   }
  // };

  const handleOk = (e) => {
    // console.log(e);
    setViewModal(false);
  };

  const handleCancel = (e) => {
    // console.log(e);
    setViewModal(false);
  };

  //サーベイシーズン絞り込みのクリア（×）ボタン押下時：
  //シーズン選択を解除し、受講者一覧を全件表示に戻す。
  //従来はページ更新が必要だったが、その操作をボタン化したもの。
  const onClearSeasonFilter = () => {
    setSelSurveySeasonIdFilter('');
    setSelSurveySeason([]);
    setSelQuestionSetFilterId('');
    setQuestionSetFilter([]);
    setIsAnswerd(9);
    // 一覧を再取得して復元（ページ更新に相当）
    readDB();
  };

  const onChangeSeasonFilter = async (value) => {
    // console.log(`selected ${value}`);
    // クリア（×）で value が undefined の場合は選択解除処理へ
    if (!value) {
      onClearSeasonFilter();
      return;
    }
    setIsAnswerd(9);
    setSelSurveySeasonIdFilter(value);
    setSelQuestionSetFilterId('');
    setQuestionSetFilter([]);
    const selSeasonInfo = surveySeason.find((item) => item._id === value);
    setSelSurveySeason(selSeasonInfo);
    const arrQuestionSet = selSeasonInfo.question_set;
    setQuestionSetFilter(arrQuestionSet);
    const gUserArr = [];
    if (selSeasonInfo.survey_code === '40010') {
      //360度診断の場合
      // console.log({ selSeasonInfo });
      selSeasonInfo.relation_360.map((element) => {
        // userIdArr.push(element.user_id);
        // bossArr.push(element.boss);
        // partnerArr.push(element.partner);
        gUserArr.push(tUsers.find((item) => item._id === element.user_id)); //本人のみをFilter
        // console.log({ gUserArr });
      });
      // 一覧に出ない本人（シーズン管理者の範囲外など）は除く（undefined のままだと computCnt で落ちる）
      setUsers(computCnt(gUserArr.filter(Boolean), value));
    } else {
      for (let i = 0; i < tUsers.length; i++) {
        const element = tUsers[i];
        let token = {};
        if (element.survey_token) {
          token = element.survey_token.find(
            (item) => item.survey_season_id === value
          );
        }
        if (token) {
          gUserArr.push(element);
        }
      }
      setUsers(computCnt(gUserArr, value));
      // console.log({ value });
      // console.log({ selSeasonInfo });
      // console.log({ gUserArr });
    }
  };

  //設問セットを変更した場合
  const onChangeQuestionFilter = (value) => {
    setSelQuestionSetFilterId(value); //選択した設問セットIDを格納
    // const selQuestionSet = questionSetFilter.find((item) => item._id === value);
    // setSelQuestionSetFilter(selQuestionSet); //現在選択したQuestionSet
    // console.log({ questionSetFilter });

    setIsAnswerd(9);
    // console.log({ gUsers });
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        // if (isAnswerd === 9) {
        token = element.survey_token.find(
          (item) =>
            item.question_set_id === value &&
            item.survey_season_id === selSurveySeasonIdFilter
        );
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setUsers(gUserArr);
  };

  //実施有無
  const onChangeAnswer = (value) => {
    // console.log({ value });
    setIsAnswerd(value);
    const gUserArr = [];
    for (let i = 0; i < tUsers.length; i++) {
      const element = tUsers[i];
      let token = {};
      if (element.survey_token) {
        if (value === 9) {
          if (selQuestionSetFilterId) {
            token = element.survey_token.find(
              (item) =>
                item.question_set_id === selQuestionSetFilterId &&
                item.survey_season_id === selSurveySeasonIdFilter
            );
          } else {
            token = element.survey_token.find(
              (item) => item.survey_season_id === selSurveySeasonIdFilter
            );
          }
        } else {
          // 未回答(0) = 選択シーズン内の 実施前(0)・一時保存中(1)・期限切れ(7)、回答済み(5) = 5 のみ。
          // ※ 以前は未回答が 0 のみで一時保存中・期限切れが漏れていた（RespondentMgrPage と基準を統一）。
          const targetStatuses = value === 0 ? UNANSWERED_STATUSES : [value];
          token = element.survey_token.find(
            (item) =>
              item.survey_season_id === selSurveySeasonIdFilter &&
              (!selQuestionSetFilterId ||
                item.question_set_id === selQuestionSetFilterId) &&
              targetStatuses.includes(item.survey_status)
          );
        }
      }
      if (token) {
        gUserArr.push(element);
      }
    }
    // console.log({ gUserArr });
    setUsers(gUserArr);
  };

  const computCnt = (gUserArr, value) => {
    gUserArr.map((user) => {
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.surveyProgress = 0;
      } else {
        user.takeTokenCnt = user.survey_token.filter(
          (tokenInfo) => tokenInfo.survey_season_id === value
        ).length;
        user.usedTokenCnt = user.survey_token.filter(
          (tokenInfo) =>
            tokenInfo.survey_season_id === value &&
            tokenInfo.survey_status === 5
          //実施済み：5
        ).length;
        user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      }
      return user;
    });
    return gUserArr;
  };
  // const downloadPdfHandler = async () => {
  //   try {
  //     // console.log({ usr });
  //     //zipのFileStreamを持ってくる
  //     const res = await Axios.get(
  //       `/api/downloadZipReport/${usr.userData.groupCode}`,
  //       {
  //         responseType: 'arraybuffer',
  //         headers: { Accept: 'application/zip' },
  //       }
  //     );
  //     // console.log({ res });
  //     //持ってきたzipのFileStreamをblobに格納し仮想のリンクでブラウザdownloadさせる
  //     if (res.data) {
  //       const blob = new Blob([res.data], { type: 'application/zip' });
  //       const fileDownloadUrl = URL.createObjectURL(blob);
  //       // console.log(fileDownloadUrl);
  //       let tempLink = document.createElement('a');
  //       tempLink.href = fileDownloadUrl;
  //       tempLink.download = 'Recurrent_Survey_Report.zip';
  //       tempLink.click();
  //     }
  //     return true;
  //   } catch (error) {
  //     console.log(error);
  //     return false;
  //   }
  // };

  // const showConfirm = async () => {
  //   confirm({
  //     title: 'サーベイ結果をダウンロードしますか？',
  //     content: 'サーベイ結果がZIP形式ファイルでダウンロードされます。',
  //     async onOk() {
  //       const result = await downloadPdfHandler();
  //       if (result) {
  //         message.success('ダウンロード完了しました。');
  //       } else {
  //         console.log('サーベイ結果ダウンロードで問題が発生しました。');
  //         message.success('サーベイ結果ダウンロードで問題が発生しました。');
  //       }
  //       // return new Promise((resolve, reject) => {
  //       //   // setTimeout(Math.random() > 0 ? resolve : reject, 3000);
  //       //   const result = downloadPdfHandler();
  //       //   if (result) {
  //       //     resolve();
  //       //   } else {
  //       //     reject();
  //       //   }
  //       // }).catch(() =>
  //       //   console.log('サーベイ結果ダウンロードで問題が発生しました。')
  //       // );
  //     },
  //     async onCancel() {},
  //   });
  // };

  const showConfirm = async (tokenI, type) => {
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        tokenI.type = type; //1:個人用、2:共有用, 30010:E3-Survey
        tokenI.training_start_date = selSurveySeason.training_start_date;
        tokenI.training_end_date = selSurveySeason.training_end_date;
        tokenI.survey_start_date = selSurveySeason.survey_start_date;
        tokenI.survey_end_date = selSurveySeason.survey_end_date;
        let result = {};
        if (type === 30010) {
          result = await Axios.post(
            '/api/dbModel100/makeReport30010Personal',
            tokenI
          );
        } else if (type == 10010 || type == 90101) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport', tokenI);
          // result.data.success = false;
        } else if (type == 50010 || type == 90501) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50010', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50020 || type == 90502) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50020', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 50030 || type == 90503) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport50030', tokenI);
        } else if (type == 50040) {
          //ソーシャルスタイル診断（コース版90504は未実装）
          result = await Axios.post('/api/dbModel100/makeReport50040', tokenI);
          // result.data.success = false;
          // console.log({ result });
        } else if (type == 60010 || type == 90601) {
          // console.log({ type });
          result = await Axios.post('/api/dbModel100/makeReport60010', tokenI);
          // result.data.success = false;
        }
        // console.log({ result });
        if (result.data.success) {
          // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  const csvDownloadHandler = async (event) => {
    event.preventDefault();
    // console.log({ gUsers });
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makecsv',
        duration: 20,
      });
      const tempData = {};
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet('sheet1');
      const worksheet = workbook.getWorksheet('sheet1');
      let columns = [
        { header: 'ID', key: 'user_id' },
        { header: '会社名', key: 'company' },
        { header: '部署名', key: 'department' },
        { header: 'eメール', key: 'email' },
        { header: '名前', key: 'fullname' },
        { header: '社員番号', key: 'empNo' },
        { header: 'ロール', key: 'roletext' },
      ];
      worksheet.columns = columns;
      // 詳細検索が適用されている場合、画面表示と一致させるためdisplayUsersを対象とする
      const exportUsers = displayUsers;
      for (let i = 0; i < exportUsers.length; i++) {
        const element = exportUsers[i];
        tempData.user_id = element._id;
        tempData.company = element.company;
        tempData.department = element.department;
        tempData.email = element.email;
        tempData.fullname = element.fullName;
        tempData.empNo = element.emp_no;
        tempData.roletext = element.roleText;

        worksheet.addRow(tempData);
      }
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], {
        type: 'application/octet-binary',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      // ファイル名生成：シーズン未選択時はグループコードで代替、それもない場合は'AllUsers'
      const seasonPart =
        selSurveySeason && selSurveySeason.season_name
          ? selSurveySeason.season_name
          : (usr.userData && usr.userData.groupCode) || 'AllUsers';
      if (selQuestionSetFilterId) {
        let selQuestionSetInfo = questionSetFilter.find(
          (item) => item._id === selQuestionSetFilterId
        );
        a.download = `Recurrent_Sruvey_RawData_${seasonPart}_${selQuestionSetInfo.set_name}_${isAnswerd}.xlsx`;
      } else {
        a.download = `Recurrent_Sruvey_RawData_${seasonPart}_${isAnswerd}.xlsx`;
      }
      a.click();
      // ダウンロード後は不要なのでaタグを除去
      a.remove();
      // console.log({ excelData });
      // console.log(excelData.length);
      message.success({
        content: 'ダウンロード完了！',
        key: 'makecsv',
        duration: 2,
      });
    } catch (error) {
      console.log({ error });
      message.error({
        content: 'ダウンロード失敗！',
        key: 'makecsv',
        duration: 2,
      });
    }
  };

  // テーブル強化 PJ Ph.3: メイン一覧テーブルの <Column> → columns 配列。
  // テキスト列はソート + 省略、チケット/進捗はソート、確認列は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 160,
      sorter: textSorter('fullName'),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 220,
      sorter: textSorter('email'),
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 160,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 140,
      sorter: textSorter('department'),
    }),
    {
      title: 'チケット発行',
      key: 'action',
      width: 280,
      sorter: numberSorter('takeTokenCnt'),
      render: (text, record) => (
        <span>
          {record.takeTokenCnt !== 0 &&
          record.takeTokenCnt === record.usedTokenCnt ? (
            <Text mark>
              {'チケット発行数：' +
                record.takeTokenCnt +
                ' | 実施済：' +
                record.usedTokenCnt}
            </Text>
          ) : record.takeTokenCnt !== 0 ? (
            <Text type="danger">
              {' チケット発行数：' +
                record.takeTokenCnt +
                ' | 実施済：' +
                record.usedTokenCnt}
            </Text>
          ) : (
            <Text>
              {' チケット発行数：' +
                record.takeTokenCnt +
                ' | 実施済：' +
                record.usedTokenCnt}
            </Text>
          )}
        </span>
      ),
    },
    {
      title: '進捗率',
      key: 'ticket',
      width: 100,
      sorter: numberSorter('surveyProgress'),
      render: (text, record) => (
        <span>
          <Text>{record.surveyProgress.toFixed(1) + '%'}</Text>
        </span>
      ),
    },
    {
      title: 'サーベイチケット確認',
      key: 'viewPdf',
      width: 160,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={(e) => viewTicketHandler(record, e)}
            disabled={
              record.role === 0 || record.takeTokenCnt < 1 ? true : false
            }
          >
            チケット詳細
          </Button>
        </span>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  // テーブル強化 拡大: モーダル（発行チケット確認）内のトークン一覧テーブルにも適用。
  const modalRawColumns = [
    ellipsisColumn({
      title: 'サーベイ名',
      dataIndex: 'surveyName',
      key: 'surveyName',
      width: 240,
      sorter: textSorter('surveyName'),
    }),
    ellipsisColumn({
      title: '状態',
      dataIndex: 'surveyStatusName',
      key: 'surveyStatusName',
      width: 120,
      sorter: textSorter('surveyStatusName'),
    }),
    {
      title: 'サーベイ実施日',
      dataIndex: 'update',
      key: 'update',
      width: 160,
      sorter: textSorter('update'),
    },
    {
      title: '結果確認',
      key: 'action',
      width: 200,
      render: (text, record) => (
        <span>
          {record.survey_code === '10010' ||
          record.survey_code === '90101' ||
          record.survey_code === '50010' ||
          record.survey_code === '90501' ||
          record.survey_code === '50020' ||
          record.survey_code === '50030' ||
          record.survey_code === '50040' ||
          record.survey_code === '90502' ||
          record.survey_code === '90503' ||
          record.survey_code === '60010' ||
          record.survey_code === '90601' ? (
            <Button
              type={'primary'}
              size="small"
              onClick={(e) => showConfirm(record, record.survey_code)}
              disabled={record.survey_status === 5 ? false : true}
            >
              サーベイ結果確認 &nbsp;{' '}
              <BsBoxArrowUpRight style={{ fontSize: '16px' }} />
            </Button>
          ) : (
            // 30010（E³-Survey）はパーソナル診断レポートのため、企業側管理者
            // （role 3/企業管理者・role 7/シーズン管理者）には結果を開示しない。
            // 実施済み（survey_status===5）等の条件が揃っても「個別結果はありません」と
            // 表示し、PDF 生成（makeReport30010Personal）・リンクを行わない。
            // ※ 90301（E3-Surveyコース）も同様に非開示とする。
            <Button type={'primary'} size="small" disabled={true}>
              個別結果はありません
            </Button>
          )}
        </span>
      ),
    },
    {
      title: 'DL',
      dataIndex: 'dlCount',
      key: 'dlCount',
      width: 80,
      align: 'center',
      sorter: numberSorter('dlCount'),
      render: (text) => (text ? text : 0),
    },
  ];

  const {
    columns: modalColumns,
    components: modalComponents,
    scroll: modalScroll,
    wrapRef: modalWrapRef,
  } = useResizableColumns(modalRawColumns);

  return (
    <Fragment>
      <PageContainer fluid>
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          ■絞り込み｜サーベイシーズン選択：
          <Select
            showSearch
            allowClear
            style={{ marginLeft: 5, marginRight: 5, width: 400 }}
            placeholder="シーズン選択"
            optionFilterProp="children"
            onChange={onChangeSeasonFilter}
            value={selSurveySeasonIdFilter || undefined}
            disabled={
              filterStatusSeasons(groupSeason, usr.userData).length === 0
            }
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {filterStatusSeasons(groupSeason, usr.userData).map(
              (element) => {
                return (
                  <Option value={element._id} key={element._id}>
                    {element.season_name}
                  </Option>
                );
              }
            )}
          </Select>
          {filterStatusSeasons(groupSeason, usr.userData).length === 0 && (
            <Text type="danger" style={{ display: 'block', marginTop: 6 }}>
              {noAccessibleSeasonMessage(usr.userData)}
            </Text>
          )}
          {questionSetFilter.length > 0 && (
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 200,
              }}
              placeholder="設問セット選択"
              optionFilterProp="children"
              onChange={onChangeQuestionFilter}
              value={selQuestionSetFilterId}
              defaultValue={questionSetFilter[0].set_name}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {questionSetFilter.map((element) => {
                return (
                  <Option value={element._id} key={element._id}>
                    {element.set_name}
                  </Option>
                );
              })}
            </Select>
          )}
          <Fragment>
            実施選択：
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 100,
              }}
              placeholder="対象選択"
              optionFilterProp="items"
              onChange={onChangeAnswer}
              value={isAnswerd}
              disabled={!selSurveySeasonIdFilter}
            >
              <Option value={9} key={9}>
                全員
              </Option>
              <Option value={0} key={0}>
                未回答
              </Option>
              <Option value={5} key={5}>
                回答済み
              </Option>
            </Select>
          </Fragment>
          <Button
            type="primary"
            onClick={csvDownloadHandler}
            disabled={displayUsers.length === 0}
          >
            CSVダウンロード
          </Button>{' '}
          <Fragment>対象者：{displayUsers.length}名</Fragment>
          {/* 詳細検索トグル（■絞り込み行の最右端） */}
          <Button
            style={{ marginLeft: 8 }}
            onClick={() => setShowAdvancedSearch((v) => !v)}
          >
            詳細検索 {showAdvancedSearch ? '▲' : '▼'}
          </Button>
          {hasActiveSearch && (
            <StatusBadge tone="processing" style={{ marginLeft: 6 }}>
              条件適用中
            </StatusBadge>
          )}
          {/* 詳細検索パネル：名前・メール・権限の絞り込み */}
          {showAdvancedSearch && (
            <div
              style={{
                marginTop: 8,
                padding: 8,
                background: 'var(--grey-10)',
                borderRadius: 4,
              }}
            >
              名前：
              <Input
                style={{ width: 180, marginLeft: 4, marginRight: 12 }}
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                placeholder="名前検索"
                allowClear
              />
              メール：
              <Input
                style={{ width: 220, marginLeft: 4, marginRight: 12 }}
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
                placeholder="メール検索"
                allowClear
              />
              権限付与：
              <Select
                mode="multiple"
                style={{ minWidth: 260, marginLeft: 4, marginRight: 12 }}
                value={searchRoles}
                onChange={(values) => setSearchRoles(values)}
                placeholder="権限選択"
                allowClear
              >
                <Option value={1}>受講者</Option>
                <Option value={7}>シーズン管理者</Option>
                <Option value={3}>企業管理者</Option>
              </Select>
              <Button size="small" onClick={clearAdvancedSearch}>
                クリア
              </Button>
            </div>
          )}
        </div>
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={displayUsers}
            size="middle"
            rowKey="email"
            pagination={{
              defaultPageSize: 100,
              showSizeChanger: true,
              pageSizeOptions: ['50', '100', '200', '500'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} / ${total}件`,
            }}
          />
        </div>

        {/* <Button
          type="primary"
          size="small"
          onClick={showConfirm}
          disabled={downloadToken.length < 1 ? true : false}
        >
          結果PDFファイル一括ダウンロード({downloadToken.length}件)
        </Button> */}
      </PageContainer>

      <div>
        <Modal
          title="サーベイチケット確認"
          open={viewModal}
          onOk={handleOk}
          onCancel={handleCancel}
          styles={{ body: { overflowX: 'scroll' } }}
          width={900}
        >
          <div style={{ width: '100%', margin: '0rem auto' }}>
            <div ref={modalWrapRef}>
              <Table
                columns={modalColumns}
                components={modalComponents}
                scroll={modalScroll}
                dataSource={userToken}
                size="middle"
                rowKey="_id"
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="サーベイ結果ファイル生成中..."
          open={isModalVisible}
          okButtonProps={{ disabled: true }}
          cancelButtonProps={{ disabled: true }}
          styles={{ body: { textAlign: 'center' } }}
        >
          <Spin size="large" />
        </Modal>
      </div>
    </Fragment>
  );
}

export default CorpMgrPage;
